import { getTableRows } from "./wax-chain";
export async function fetchRarityConfigs() {
    const r = await getTableRows("s.rplanet", "s.rplanet", "collections");
    return r.rows;
}
export async function fetchStakingConfigs() {
    const r = await getTableRows("s.rplanet", "s.rplanet", "pools");
    return r.rows;
}
export async function fetchRateMods() {
    var _a;
    const map = new Map();
    let mods;
    let nextKey;
    do {
        mods = await getTableRows("s.rplanet", "atomicassets", "ratemods", nextKey);
        mods.rows.forEach((m) => map.set(m.id, m));
        nextKey = (_a = mods.next_key) === null || _a === void 0 ? void 0 : _a.toString();
    } while (nextKey);
    return map;
}
export async function fetchAccountCollectionStaking(account, collection) {
    const result = await getTableRows("s.rplanet", collection, "accounts", account, account);
    const staking = result.rows[0];
    if (staking) {
        staking.collection = collection;
    }
    return staking;
}
